import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from '../components/Arrow';
export function getArrows(nodes, options = {}) {
    const status = { level: 0 };
    const arrows = [];
    getArrowsSS(nodes, arrows, status, options);
    return arrows;
}
function getArrowsSS(nodes, arrows, status, options = {}) {
    const { getLabel, horizontalPosition, getID, verticalPosition } = options;
    for (const node of nodes) {
        if (node.children) {
            for (const child of node.children) {
                arrows.push(_jsx(Arrow, { id: getID ? getID(node) : undefined, from: node.anchor.right, to: child.anchor.left, label: getLabel?.(child), horizontalPosition: horizontalPosition, verticalPosition: verticalPosition }, arrows.length));
            }
            getArrowsSS(node.children, arrows, {
                ...status,
                level: status.level + 1,
            }, options);
        }
    }
}
//# sourceMappingURL=getArrows.js.map